/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at <http://mozilla.org/MPL/2.0/>. */

//
import React from "react";

const Badge = ({ children }) => <span className="badge text-center">{children}</span>;

export default Badge;
